<script setup lang="ts">
import type { EditorMode } from '@/types/editor';

import { useEditor } from '@/composables/useEditor';

import SelectionAuto from './SelectionAuto.vue';
import SelectionManual from './SelectionManual.vue';

const { mode } = useEditor();

const editorModes = new Array<EditorMode>('manual', 'auto');
</script>

<template>
  <div class="widget-editor">
    <div class="selection-modes">
      <div
        v-for="editorMode in editorModes"
        :key="editorMode"
        role="button"
        tabindex="0"
        class="selection-mode"
        :data-enabled="mode === editorMode"
        @click="mode = editorMode"
        @keydown.enter="mode = editorMode"
      >
        {{ $t(`editor.selection.${editorMode}`) }}
      </div>
    </div>
    <SelectionAuto v-if="mode === 'auto'" class="widget-editor-content" />
    <SelectionManual v-else class="widget-editor-content" />
  </div>
</template>

<style scoped>
.widget-editor {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
  flex: 1;
}

.selection-modes {
  display: flex;
  gap: 1rem;

  .selection-mode {
    padding: 0.5rem 1rem;
    border-radius: 10px;
    cursor: pointer;
  }

  .selection-mode[data-enabled='true'] {
    background: #252525;
    color: white;
    font-weight: 600;
  }

  .selection-mode[data-enabled='false'] {
    background: lightgrey;
    color: white;
    font-weight: 600;
  }
}

.widget-editor-content {
  display: flex;
  flex: 1;
  min-height: 450px;
  overflow: auto;
  padding-right: 1rem;
}
</style>
